import React from 'react'

function Signup() {
  return (
    <>
      <div class="form-outline col-xs-6 col-xs-offset-3">
        <label class="form-label " for="typeEmail"  >Email input</label>
        <input type="email" id="typeEmail" class="form-control" style={{alignContent:'center'}} />
        <h1>THIS AREA IS UNDER CONSTRUCTION</h1>
      </div>
    </>
  )
}

export default Signup
